import { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './PrivacyPolicy.css';

/**
 * Страница Политики конфиденциальности
 */
const PrivacyPolicy = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Секции для навигации в Header
  const sections = [
    { id: '/', label: 'Home' },
    { id: '/privacy-policy', label: 'Privacy Policy' },
    { id: '/terms-of-service', label: 'Terms of Service' }
  ];

  return (
    <div className="privacy-page">
      <Header sections={sections} onJoinClick={openModal} />
      
      {/* Фон с двумя зелеными кругами */}
      <div className="page-background">
        <div className="green-circle green-circle-1"></div>
        <div className="green-circle green-circle-2"></div>
      </div>

      {/* Центральное окно с контентом */}
      <main className="content-container">
        <div className="content-box">
          <h1 className="page-title">Privacy Policy</h1>
          <p className="page-subtitle">Last Updated: November 7, 2025</p>

          <section className="content-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to Debt Agent. We respect your privacy and are committed to protecting your 
              personal information. This Privacy Policy explains how we collect, use, disclose, and 
              safeguard your information when you use our website and services.
            </p>
            <p>
              Please read this Privacy Policy carefully. If you do not agree with the terms of this 
              policy, please do not use our site. By using our site, you consent to the collection 
              and use of information in accordance with this policy.
            </p>
          </section>

          <section className="content-section">
            <h2>2. Information We Collect</h2>
            <p>
              We may collect various types of information from and about you, including:
            </p>
            
            <h3>2.1. Personal Information</h3>
            <ul>
              <li><strong>Contact Information:</strong> name, email address, phone number, mailing address</li>
              <li><strong>Financial Information:</strong> information about debts, income, credit history</li>
              <li><strong>Identification Information:</strong> date of birth, social security number (when necessary)</li>
              <li><strong>Account Information:</strong> username, password, preferences</li>
            </ul>

            <h3>2.2. Automatically Collected Information</h3>
            <ul>
              <li><strong>Usage Data:</strong> information about how you use our site</li>
              <li><strong>Technical Data:</strong> IP address, browser type, operating system</li>
              <li><strong>Cookies:</strong> data stored on your device to improve site functionality</li>
              <li><strong>Analytics Data:</strong> information about page visits, time on site, traffic sources</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>3. How We Use Your Information</h2>
            <p>
              We use the collected information for various purposes, including:
            </p>
            <ul>
              <li><strong>Providing Services:</strong> processing your requests and providing our debt management services</li>
              <li><strong>Communication:</strong> contacting you about your account, services, and updates</li>
              <li><strong>Service Improvement:</strong> analyzing usage to improve our site and services</li>
              <li><strong>Personalization:</strong> customizing your experience based on your preferences</li>
              <li><strong>Security:</strong> protecting against fraud and ensuring the security of our site</li>
              <li><strong>Legal Compliance:</strong> fulfilling legal obligations and protecting our rights</li>
              <li><strong>Marketing:</strong> sending you information about our services (with your consent)</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>4. Disclosure of Your Information</h2>
            <p>
              We may disclose your personal information in the following circumstances:
            </p>
            
            <h3>4.1. Service Providers</h3>
            <p>
              We may share your information with third parties who provide services on our behalf, such as:
            </p>
            <ul>
              <li>Payment processing</li>
              <li>Data hosting and cloud services</li>
              <li>Analytics and research</li>
              <li>Marketing and communications</li>
              <li>Legal and consulting services</li>
            </ul>

            <h3>4.2. Legal Requirements</h3>
            <p>
              We may disclose your information if required by law or in response to:
            </p>
            <ul>
              <li>Subpoenas or court orders</li>
              <li>Law enforcement requests</li>
              <li>Protection of our rights and safety</li>
              <li>Investigation of fraud or security breaches</li>
            </ul>

            <h3>4.3. Business Transitions</h3>
            <p>
              In the event of a merger, acquisition, or sale of assets, your personal information may be 
              transferred to the new owner.
            </p>
          </section>

          <section className="content-section">
            <h2>5. Data Security</h2>
            <p>
              We take reasonable measures to protect your personal information from unauthorized access, 
              use, or disclosure. Our security measures include:
            </p>
            <ul>
              <li><strong>Encryption:</strong> using SSL/TLS to protect data during transmission</li>
              <li><strong>Access Control:</strong> limiting access to personal information to authorized employees only</li>
              <li><strong>Secure Storage:</strong> storing data on protected servers</li>
              <li><strong>Regular Audits:</strong> conducting security reviews and system updates</li>
              <li><strong>Staff Training:</strong> training employees in data protection practices</li>
            </ul>
            <p>
              However, please remember that no method of transmission over the Internet or method of 
              electronic storage is 100% secure. We cannot guarantee the absolute security of your information.
            </p>
          </section>

          <section className="content-section">
            <h2>6. Your Rights and Choices</h2>
            <p>
              Depending on your location, you may have the following rights regarding your personal information:
            </p>
            <ul>
              <li><strong>Access:</strong> right to request a copy of your personal information</li>
              <li><strong>Correction:</strong> right to correct inaccurate or incomplete information</li>
              <li><strong>Deletion:</strong> right to request deletion of your personal information</li>
              <li><strong>Restriction:</strong> right to restrict the processing of your information</li>
              <li><strong>Portability:</strong> right to receive your information in a structured format</li>
              <li><strong>Objection:</strong> right to object to the processing of your information</li>
              <li><strong>Withdrawal of Consent:</strong> right to withdraw previously given consent</li>
            </ul>
            <p>
              To exercise these rights, please contact us at privacy@debtagent.com.
            </p>
          </section>

          <section className="content-section">
            <h2>7. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies and similar tracking technologies to improve your experience on our site. 
              Cookies are small data files stored on your device.
            </p>
            
            <h3>7.1. Types of Cookies We Use:</h3>
            <ul>
              <li><strong>Essential Cookies:</strong> required for the site to function</li>
              <li><strong>Functional Cookies:</strong> remember your preferences</li>
              <li><strong>Analytics Cookies:</strong> help us understand how the site is used</li>
              <li><strong>Marketing Cookies:</strong> used to display relevant advertising</li>
            </ul>

            <h3>7.2. Managing Cookies</h3>
            <p>
              You can manage cookie settings through your browser settings. Please note that disabling 
              cookies may affect the functionality of the site.
            </p>
          </section>

          <section className="content-section">
            <h2>8. Data Retention</h2>
            <p>
              We retain your personal information only as long as necessary for the purposes stated in 
              this Privacy Policy or as required by law.
            </p>
            <p>
              Criteria used to determine the retention period include:
            </p>
            <ul>
              <li>Duration of our relationship with you</li>
              <li>Existence of legal obligations to retain data</li>
              <li>Necessity of data to protect our interests</li>
              <li>Recommendations from regulatory authorities</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>9. Children's Privacy</h2>
            <p>
              Our service is not intended for individuals under 18 years of age. We do not knowingly 
              collect personal information from children under 18. If you are a parent or guardian and 
              know that your child has provided us with personal information, please contact us.
            </p>
            <p>
              If we learn that we have collected personal information from a child under 18 without 
              verification of parental consent, we will take steps to remove that information from our servers.
            </p>
          </section>

          <section className="content-section">
            <h2>10. International Data Transfers</h2>
            <p>
              Your information may be transferred to and stored on computers located outside of your 
              state, province, country, or other governmental jurisdiction where data protection laws 
              may differ.
            </p>
            <p>
              If you are located outside the United States and choose to provide information to us, 
              please note that we transfer data, including personal information, to the United States 
              and process it there.
            </p>
            <p>
              Your consent to this Privacy Policy followed by your submission of such information 
              represents your agreement to that transfer.
            </p>
          </section>

          <section className="content-section">
            <h2>11. Changes to Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by 
              posting the new Privacy Policy on this page and updating the "Last Updated" date at the 
              top of the document.
            </p>
            <p>
              We may also notify you via email and/or a prominent notice on our service before the 
              change becomes effective.
            </p>
            <p>
              We recommend that you review this Privacy Policy periodically for any changes. Changes 
              to this Privacy Policy are effective when they are posted on this page.
            </p>
          </section>

          <section className="content-section">
            <h2>12. Links to Other Sites</h2>
            <p>
              Our service may contain links to other sites that are not operated by us. If you click 
              on a third-party link, you will be directed to that third party's site.
            </p>
            <p>
              We strongly advise you to review the Privacy Policy of every site you visit. We have no 
              control over and assume no responsibility for the content, privacy policies, or practices 
              of any third-party sites or services.
            </p>
          </section>

          <section className="content-section">
            <h2>13. Contact Information</h2>
            <p>
              If you have questions about this Privacy Policy or wish to exercise your rights, please 
              contact us:
            </p>
            <ul className="contact-list">
              <li><strong>Email:</strong> privacy@debtagent.com</li>
              <li><strong>Phone:</strong> +1 (800) 123-4567</li>
              <li><strong>Address:</strong> 123 Financial Street, Suite 100, New York, NY 10001</li>
            </ul>
            <p>
              We strive to respond to all requests within 30 days.
            </p>
          </section>

          <section className="content-section">
            <h2>14. Consent</h2>
            <p>
              By using our site, you consent to our Privacy Policy and agree to its terms. If you do 
              not agree with this policy, please do not use our site.
            </p>
            <p>
              For more information about how we use your data, please review our{' '}
              <a href="/terms-of-service" className="inline-link">Terms of Service</a>.
            </p>
          </section>
        </div>
      </main>

      <Footer />

      {/* Modal Window */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">Are you sure you want to continue?</h3>
            <div className="modal-buttons">
              <button className="modal-confirm-button" onClick={closeModal}>
                Yes
              </button>
              <button className="modal-cancel-button" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrivacyPolicy;
